module.exports = __webpack_public_path__ + "img/1557614104927084546.c7eeb753.png";